import React, { useState } from 'react';
import useModalTransition from '../../hooks/useModalTransition';
import Button from '../shared/Button';
import Icon from '../shared/Icon';
import Toggle from '../shared/Toggle';
import './AuthModal.css';
import './DevAccessModal.css';

export default function DevAccessModal({ onClose }) {
  const { isClosing, handleClose } = useModalTransition(onClose);
  const [code, setCode] = useState('');
  const [status, setStatus] = useState(null);

  function handleSubmit(e) {
    e.preventDefault();
    setStatus({
      type: 'info',
      message: 'Beta administration is managed at fitndex.com/beta.',
    });
  }

  return (
    <div
      className={`auth-modal-overlay${isClosing ? ' anim-fade-out' : ''}`}
      onClick={(e) => e.target === e.currentTarget && handleClose()}
    >
      <div
        className={`auth-modal ${isClosing ? 'anim-fade-out-scale' : 'anim-fade-in-scale'}`}
        role="dialog"
        aria-modal="true"
        aria-label="Admin access"
      >
        <div className="auth-modal__header dev-access__header">
          <div>
            <span className="dev-access__restricted">Restricted</span>
            <h2 className="dev-access__title">Admin Access</h2>
          </div>
          <div className="dev-access__header-actions">
            <Toggle />
            <button className="auth-modal__close" onClick={handleClose} aria-label="Close">
              <Icon name="close" size={16} />
            </button>
          </div>
        </div>

        <form className="auth-modal__form" onSubmit={handleSubmit} noValidate>
          <p className="dev-access__lead">Enter the access code to manage beta invitations.</p>

          <div className="auth-modal__field">
            <label className="auth-modal__label" htmlFor="dev-access-code">Access code</label>
            <input
              id="dev-access-code"
              name="dev-access-code"
              className="auth-modal__input"
              type="password"
              value={code}
              onChange={(e) => { setCode(e.target.value); setStatus(null); }}
              autoComplete="one-time-code"
              autoCorrect="off"
              spellCheck="false"
              required
            />
          </div>

          {status && (
            <div className={`auth-modal__result auth-modal__result--${status.type}`} role="status">
              <span>{status.message}</span>
            </div>
          )}

          <Button type="submit" variant="primary" size="lg" className="auth-modal__submit">
            Continue
          </Button>
        </form>
      </div>
    </div>
  );
}
